export default {
    savings: {
        name: 'Amount to Savings',
        category:'Saving & Debt',
        type:'saving'
    },
    mortgage_and_rent: {
        name: 'Rent or Mortgage Payments',
        category:'Rent or Mortgage Payments',
        type:'needs'
    },
    vehicle_purchase_and_lease: {
        name: "Vehicle Payment",
        category:'Car Payment',
        type:'wants'
    },
    other_debt_payments: {
        name: "Other Debt Payments",
        category:'Saving & Debt',
        type:'saving'
    },
    life_and_personal_insurance: {
        name: "Life & Personal Insurance",
        category:'Life & Other Personal Insurance',
        type:'needs'
    },
    cash_contributions: {
        name: "Charitable Giving",
        category:'Charitable Giving',
        type:'wants'
    },
    miscellaneous: {
        name: "Miscellaneous",
        category:'Miscellaneous',
        type:'wants'
    },
    tobacco_and_smoking: {
        name: "Smoking & Vaping",
        category:'Miscellaneous',
        type:'wants'
    },
    education: {
        name: "Education & Childcare",
        category:'Education',
        type:'wants'
    },
    reading: {
        name: "Books & Subscriptions",
        category:'Miscellaneous',
        type:'wants'
    },
    personal_care: {
        name: "Personal Care",
        category:'Personal Care Products and Services',
        type:'wants'
    },
    toys_and_hobbies: {
        name: "Hobbies & Recreation",
        category:'Fun & Leisure',
        type:'wants'
    },
    pets: {
        name: "Pets",
        category:'Pets',
        type:'wants'
    },
    media_hardware_and_services: {
        name: "TV/Audio Equipment & Streaming",
        category:'Cable / Internet / Home Entertainment',
        type:'wants'
    },
    fees_and_admissions: {
        name: "Events & Entertainment",
        category:'Fun & Leisure',
        type:'wants'
    },
    medical_supplies: {
        name: "Medical Supplies",
        category:'Medical Spending',
        type:'needs'
    },
    prescription_drugs: {
        name: "Prescriptions",
        category:'Medical Spending',
        type:'needs'
    },
    medical_services: {
        name: "Medical Services",
        category:'Medical Spending',
        type:'needs'
    },
    health_insurance: {
        name: "Health Insurance",
        category:'Health Insurance',
        type:'needs'
    },
    public_and_other_transportation: {
        name: "Public Transportation",
        category:'Transportation Fares',
        type:'needs'
    },
    vehicle_insurance: {
        name: "Vehicle Insurance",
        category:'Car Insurance',
        type:'needs'
    },
    vehicle_maintenance_and_repairs: {
        name: "Vehicle Maintenance",
        category:'Car Maintenance',
        type:'needs'
    },
    gasoline: {
        name: "Gasoline & EV-Charging",
        category:'Gasoline & EV-Charging',
        type:'needs'
    },
    clothing_items_and_services: {
        name: "Clothing & Jewelry",
        category:'Clothing & Jewelry',
        type:'needs'
    },
    furniture_and_appliances: {
        name: "Furniture & Appliances",
        category:'Home Appliances & Furniture',
        type:'needs'
    },
    housekeeping_supplies: {
        name: "Household Supplies",
        category:'Home Maintenance & Services',
        type:'needs'
    },
    other_household_expenses: {
        name: "Household Services",
        category:'Home Maintenance & Services',
        type:'needs'
    },
    water_and_public_services: {
        name: "Water & Sewer Bill",
        category:'Utilities - Other',
        type:'needs'
    },
    telephone_services: {
        name: "Cell Phone Bill",
        category:'Phone Services',
        type:'needs'
    },
    personal_services: {
        name: "Personal Services",
        category:'Miscellaneous"',
        type:'wants'
    },
    heating_fuels_other: {
        name: "Heating Oil & Propane",
        category:'Utilities - Other',
        type:'needs'
    },
    electricity: {
        name: "Power Bill",
        category:'Utilities - Power Bill',
        type:'needs'
    },
    natural_gas: {
        name: "Natural Gas Bill",
        category:'Utilities - Other',
        type:'needs'
    },
    other_lodging: {
        name: "Travel Accommodations",
        category:'Fun & Leisure',
        type:'wants'
    },
    home_maintenance_and_repairs: {
        name: "Home Maintenance",
        category:'Home Maintenance & Services',
        type:'needs'
    },
    alcoholic_beverages: {
        name: "Alcohol & Bars",
        category:'Groceries',
        type:'needs'
    },
    food_out: {
        name: "Dining Out",
        category:'Dining Out',
        type:'wants'
    },
    food_home: {
        name: "Groceries",
        category:'Groceries',
        type:'needs'
    },
  }
  